import { OptionCard } from '../primitives';

/**
 * PlatformChoice is the first decision of a new project: which commerce
 * platform it runs. Each platform has its own onboarding page, so each
 * option is a link to that page rather than a toggle that reshapes a shared
 * form — it opens in a new tab like any other link.
 */
export function PlatformChoice({ selected }: { selected: 'magento' | 'wordpress' }) {
  return (
    <nav className="platform-choice" aria-labelledby="platform-choice-label" data-testid="platform-choice">
      <span id="platform-choice-label" className="platform-choice__legend">
        Platform
      </span>
      <div className="platform-choice__options">
        <OptionCard
          to="/app/projects/new"
          selected={selected === 'magento'}
          title="Magento / Adobe Commerce"
        />
        <OptionCard
          to="/app/projects/new/wordpress"
          selected={selected === 'wordpress'}
          title="WordPress + WooCommerce"
          testId="platform-wordpress"
        />
      </div>
    </nav>
  );
}
